import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { fetchMenuStructure } from '../app-state/slices/AppDataSlice';
import { setSwitchUser, setUser } from '../app-state/slices/AuthSlice';
import { resetPortfolioClientSelection } from '../app-state/slices/ClientsSlice';
import { resetGeneratedReports } from '../app-state/slices/ReportsSlice';
import { AppDispatch } from '../app-state/store';
import apiClient from '../canopy-ui-components/api';
import LoginPage from '../canopy-ui-components/components/LoginPage/LoginPage';
import { useGetDeviceType } from '../canopy-ui-components/hooks/UseResponsive/UseResponsive';
import AuthWrapper from '../components/Wrappers/AuthWrapper';

function Login({ t }: any) {
    const dispatch = useDispatch<AppDispatch>();
    const deviceType = useGetDeviceType();

    return (
        <AuthWrapper>
            <LoginPage
                userLabel={t('username')}
                passwordLabel={t('password')}
                onLogin={(response: any) => {
                    dispatch(
                        setUser({
                            ...response,
                            logged_in_at: Math.floor(Date.now()),
                        })
                    );
                    dispatch(setSwitchUser(null));
                    apiClient.clearSwitchedUser();
                    dispatch(resetPortfolioClientSelection());
                    dispatch(resetGeneratedReports());
                    deviceType && dispatch(fetchMenuStructure({ deviceType }));
                }}></LoginPage>
        </AuthWrapper>
    );
}

Login.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('translations')(Login);
